import { AfterContentInit, AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GetterSetter } from 'app/shared/common/helper/project';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { ToastrService } from 'ngx-toastr';
import { ProjectDataService } from '../project-data.service';

@Component({
  selector: 'app-resource-allocation',
  templateUrl: './resource-allocation.component.html',
  styleUrls: ['./resource-allocation.component.scss']
})
export class ResourceAllocationComponent implements OnInit {
  resourceDropdown = [];
  dataSources = [];
  projectId = '';
  empRole = '';
  projectValue: import('../../../../../../../../app/shared/common/helper/project').Project;
  billingType: { name: string; value: string; }[];
  selectedBilling: any;
  AllocateResources: any = [];
  tenantId: any;
  projectMembers: any[];
  projectResource: any[];
  isHours = false;
  allocatedRecordCompleted = true;
  update = false;
  BillingTypeSelected: string;
  userIds = [];
  selectedMembers = [];
  isLastResource = false;
  constructor(
    private route: ActivatedRoute,
    private storageConfiguration: StorageConfiguration,
    private projectInterface: GetterSetter,
    private queryInterface: QueryInterface,
    private parseService: ParseService,
    private projectDataService: ProjectDataService,
    private toastr: ToastrService,
  ) {
    this.billingType = this.projectDataService.billingTypeData;
    this.empRole = this.storageConfiguration.sessionGetItem(
      this.storageConfiguration.role
    );
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.getResourceType();
    // this.getProjectResource();
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.projectId = params['id'];
      // this.getAssignedResources();
      if (this.projectId != '' && this.projectId != undefined) {
        // this.getProjectInformation();
        this.update = true;
        const Project = this.parseService.instance.Object.extend('Project');
        const projectQuery = new this.parseService.instance.Query(Project);
        projectQuery.equalTo('objectId', this.projectId);
        projectQuery.find().then((projectResult) => {
          this.projectDataService.selectedBilling = projectResult[0].get('schedulerStatus');
          this.selectedBilling = this.projectDataService.selectedBilling;
          this.isHours = this.selectedBilling === 'Fixed Billable' || this.selectedBilling === 'Fixed Non-Billable' ? true : false;
        });
        this.getProjectDetails();
      }
    });
    // this.getProjectResource();
    this.getAssignedResources();
  }

  // ngAfterViewInit() {
  //   this.selectedBilling = this.projectDataService.selectedBilling;
  // }

  /*
** ==========================================================
** Get the role data for the role dropdown
** ==========================================================
*/

  async getResourceType(): Promise<void> {
    let queryInstance = this.parseService.instance.Object.extend('DataSettings');
    let query = new this.parseService.instance.Query(queryInstance);
    let results = await query.find();
    const result = results[0];
    const resourceType = result.get('resourceRole');
    this.resourceDropdown = resourceType;
    if (this.dataSources.length > 0) {
      this.dataSources.forEach(element => {
        this.resourceDropdown.splice(
          this.resourceDropdown.findIndex(a => a == element.role),
          1
        );
      });
    }
  }

  // getProjectInformation() {
  //   let condition = [];
  //   let type = '';
  //   if (this.empRole == 'Admin') {
  //     condition = [
  //       { condition: 'equalTo', field: 'objectId', value: this.projectId },
  //       { condition: 'include', value: 'client' }
  //     ];
  //     type = 'Project';
  //   } else {
  //     condition = [
  //       { condition: 'include', value: 'project' },
  //       { condition: 'include', value: 'project.client' },
  //       { condition: 'include', value: 'user' },
  //       {
  //         condition: 'equalTo', field: 'project', value: {
  //           __type: 'Pointer',
  //           className: 'Project',
  //           objectId: this.projectId
  //         }
  //       }
  //     ];
  //     type = 'ProjectMembers';
  //   }
  //   this.queryInterface.executeQuery(this.parseService, type, condition).then(results => {
  //     const result = results[0];
  //     console.log(results, 'Check');
  //     // this.projectValue = this.projectInterface.getProject(result);
  //     this.dataSources = this.projectValue.resourceDetails[0].details;
  //   });
  // }


  /*
** ==========================================================
** Add new empty record 
** ==========================================================
*/
  selectedBillingType(data): void {
    this.selectedBilling = data.value;
    this.isHours = this.selectedBilling === 'Fixed Billable' || this.selectedBilling === 'Fixed Non-Billable' ? true : false;
    if (this.selectedBilling) {
      this.AllocateResources = [];
      this.addResource();
    }
  }

  /*
** ==========================================================
** Add new empty record 
** ==========================================================
*/
  async addResource(): Promise<void> {
    if (this.projectResource.length > 0) {
      if (this.AllocateResources.length > 0) {
        this.isAllocatedRecordCompleted();
      }
      if (this.projectResource.length === 1) {
        this.isLastResource = true;
      } else {
        this.isLastResource = false;
      }
      if (this.selectedBilling) {
        if (this.allocatedRecordCompleted && !this.isLastResource) {
          await this.getProjectResource();
          if (this.projectResource.length > 0) {
            const data = {
              id: await this.getRandomNumber(9),
              role: '',
              resource: {
                userName: '',
                profileImage: ''
              },
              isCreatedNew: true
            };
            if (this.isHours) {
              data['hours'] = 0;
            } else {
              data['months'] = 0;
            }
            this.AllocateResources.push(data);
          }
        }
      } else {
        this.toastr.warning('Please select the billing type for the resource');
      }
    } else {
      this.toastr.info('No project members to assign');
    }
  }

  /*
** ==========================================================
** Check All the fields value are entered if not show error
** ==========================================================
*/

  isAllocatedRecordCompleted(): void {
    this.allocatedRecordCompleted = true;
    const notSelectedField = [];
    const allocatedRecord = this.AllocateResources[this.AllocateResources.length - 1];
    if (allocatedRecord.role === '') {
      this.allocatedRecordCompleted = false;
      notSelectedField.push('Role ');
    }
    if (allocatedRecord.resource === '') {
      this.allocatedRecordCompleted = false;
      notSelectedField.push('Resource ');
    }
    if (allocatedRecord.hours === 0 || allocatedRecord.months === 0) {
      this.allocatedRecordCompleted = false;
      notSelectedField.push(this.isHours ? 'Hours ' : 'Months ');
    }
    if (notSelectedField.length > 0) {
      this.toastr.warning('Please select' + ' ' + notSelectedField);
    }
  }

  /*
** ==========================================================
** Get resources details for the dropdown
** ==========================================================
*/

  async getProjectResource(): Promise<void> {
    const type = 'Profile';
    this.projectResource = [];
    const condition = [
      { condition: 'equalTo', field: 'isActive', value: true },
      { condition: 'include', value: 'location' },
      { condition: 'include', value: 'reportingTo' },
      { condition: 'include', value: 'department' },
      { condition: 'include', value: 'role' },
      { condition: 'ascending', value: 'firstName' },
      { condition: 'limit', value: 1000 },
      { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
      { condition: 'notContainedIn', field: 'objectId', value: [...this.userIds, ...this.selectedMembers] },
      // { condition: 'notContainedIn', field: 'objectId', value: this.userIds }
    ];
    await this.queryInterface.executeQuery(this.parseService, type, condition).then((result) => {
      // console.log('result', result);
      result.forEach(async (user) => {
        // const profileUrl = user.get('profileImageInfo') ? 
        const data = {
          userName: user.get('username'),
          profileId: user.id,
          // role : user.get('role').name,
          profileImage: '../../../../../../../../assets/images/avatars/profile.jpg'
        };
        await this.projectResource.push(data);
      });
    });
  }

  getRandomNumber(val): any {
    // const timestamp = +new Date();
    length = val;
    const date = +new Date();
    const timeStamp = date.toString();
    const parts = timeStamp.split('').reverse();
    let id = '';

    for (let i = 0; i < length; ++i) {
      const index = this.generateRandomNumber(0, parts.length - 1);
      id += parts[index];
    }
    return id;
  }

  generateRandomNumber(min, max): any {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  /*
  ** ==========================================================
  ** Delete resource type
  ** ==========================================================
  */
  async deleteResourceRecord(id, allocate?): Promise<void> {
    const index = this.selectedMembers.findIndex(x => x === allocate.resource.profileId);
    if (index !== -1) {
      this.selectedMembers.splice(index, 1);
      this.getProjectResource();
    }
    const recordId = this.AllocateResources.findIndex(element => element.id === id);
    this.AllocateResources.splice(recordId, 1);
  }

  async releaseResource(id, profileId) {

    let User = this.parseService.instance.Object.extend('_User');
    let query = new this.parseService.instance.Query(User);
    query.equalTo('profile', { __type: 'Pointer', className: 'Profile', objectId: profileId });
    let user = await query.find();
    let userId = user[0].id;

    let ProjectMembers = this.parseService.instance.Object.extend('ProjectMembers');
    let projectMemberQuery = new this.parseService.instance.Query(ProjectMembers);
    projectMemberQuery.equalTo('user', { __type: 'Pointer', className: '_User', objectId: userId });
    projectMemberQuery.equalTo('tenantId', this.tenantId);
    projectMemberQuery.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: this.projectId });
    let result = await projectMemberQuery.find();
    let releaseUser = result[0];
    releaseUser.set('status', "Released");
    releaseUser.save().then(() => {
      this.toastr.success('Project member released successfully');
    }).catch(() => {
      this.toastr.error('Project member released failed');
    });
    await this.deleteResourceRecord(id);

    const Project = this.parseService.instance.Object.extend('Project');
    const projectQuery = new this.parseService.instance.Query(Project);
    projectQuery.equalTo('objectId', this.projectId);
    projectQuery.equalTo('tenantId', this.tenantId);
    const data = await projectQuery.find();
    let updateProjectDetails = data[0];
    updateProjectDetails.set('assignMember', this.AllocateResources);
    updateProjectDetails.save();

  }

  saveResource(): void {
    this.projectDataService.allocatedResource = this.AllocateResources;
    this.projectDataService.selectedBilling = this.selectedBilling;
    if (this.update) {
      this.projectDataService.updateProjectInfo.next(true);
    }
    else {
      this.projectDataService.saveProjectStatus = false;
      this.projectDataService.saveProjectInfo.next();
    }
  }

  /*
** ==========================================================
** Update the the date like role, resource, Hours or Months
** ==========================================================
*/


  setRole(index, data): void {
    this.AllocateResources[index].role = data.value;
  }
  setResource(index, data): void {
    this.AllocateResources[index].resource = data.value;
    this.getSelectedMembers(data);
  }
  setHours(index, data): void {
    this.AllocateResources[index].hours = +data.target.value;
  }
  setMonths(index, data): void {
    this.AllocateResources[index].months = +data.target.value;
  }


  /*
** ==========================================================
** Get the project Details to patch
** ==========================================================
*/


  async getProjectDetails(): Promise<void> {
    const Project = this.parseService.instance.Object.extend('Project');
    const projectQuery = new this.parseService.instance.Query(Project);
    projectQuery.equalTo('objectId', this.projectId);
    projectQuery.equalTo('tenantId', this.tenantId);
    const data = await projectQuery.find();
    this.AllocateResources = data[0].attributes.assignMember;
    this.AllocateResources.forEach(resource => {
      resource.isCreatedNew = false;
    });
  }

  /*
  ** ==========================================================
  ** Get assigned resource details
  ** ==========================================================
  */

  async getAssignedResources(): Promise<void> {
    this.queryInterface.executeQuery(this.parseService, 'ProjectMembers', [
      { condition: 'equalTo', field: 'project', value: { __type: 'Pointer', className: 'Project', objectId: this.projectId } },
      { condition: 'equalTo', field: 'isActive', value: true },
      { condition: 'equalTo', field: 'status', value: 'Assigned' },
      { condition: 'include', value: 'user' },
      { condition: 'include', value: 'project' },
      { condition: 'include', value: 'user.profile' },
      { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
      { condition: 'ascending', value: 'username' }]).then(results => {
        results.forEach((element, index) => {
          let userObject = element.get('user');
          let profile = userObject.get('profile');
          // this.userCompareId = profile.id;
          this.userIds.push(profile.id);
        });

      }).then(() => {
        // console.log('userIds', this.userIds);
        this.getProjectResource();
      });
  }

  getSelectedMembers(data): void {
    const index = this.AllocateResources.length - 1;
    this.selectedMembers[index] = data.value.profileId;
    // console.log('selectedMembers', this.selectedMembers);
  }
  removeSelectedMembers(): void {

  }


}
